import React from 'react';
import {motion} from 'framer-motion';

import Button from '../common/Button';

import {CONSULTING_FORM_URL} from '../../config/urls';
import {useMediaQuery} from '../../hooks/useMediaQuery';
import openNewWindow from '../../utils/openNewWindow';
import styles from './styles/main-01.module.css';

import DemoVideo from '../../assets/main01/demo.mov';
// import {ReactComponent as ChartImg} from '../../assets/main01/chart.svg';
// import {ReactComponent as ChatPageImg} from '../../assets/main01/chat-page.svg';

const springMotion = {
  type: 'spring',
  mass: 1,            // 클수록 무겁게
  stiffness: 40,     // 클수록 빠르게
  damping: 10       // 움직임이 줄어드는 속도, 클수록 빠르게 안정
};

export default function Main01() {
  const mobileSmall = useMediaQuery('(max-width: 480px)');
  
  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <div className={styles.boxText}>
          {mobileSmall 
            ? <motion.p
                initial={{ opacity: 0, y: -50 }}  /* initial : 시작 상태 */
                animate={{ opacity: 1, y: 0 }}    /* animate : 종료 상태 */
                transition={springMotion}         /* transition :  애니메이션 지속 시간 및 딜레이 */
              >
                복잡한 사내 문서와 시스템…<br />여전히 헤매고 계신가요?
              </motion.p>
            : <motion.p
                initial={{ opacity: 0, y: -50 }}  /* initial : 시작 상태 */
                animate={{ opacity: 1, y: 0 }}    /* animate : 종료 상태 */
                transition={springMotion}         /* transition :  애니메이션 지속 시간 및 딜레이 */
              >
                복잡한 사내 문서와 시스템… 여전히 헤매고 계신가요?
              </motion.p>
          }
          {mobileSmall
            ? <div className={styles.contaienrText}>
                <div className={styles.boxP}>
                  <motion.p
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0, clipPath: 'inset(0 0 0 0)' }}
                    transition={springMotion}
                  >
                    데이터 연결부터,
                  </motion.p>
                </div>
                <div className={styles.boxP}>
                  <motion.p
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={springMotion}
                  >
                     업무 실행까지 도와주는
                  </motion.p>
                </div>
                <div className={styles.boxP}>
                  <motion.p
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={springMotion}
                  >
                    AI 파트너,
                  </motion.p>
                </div>
                <div className={styles.boxP}>
                  <motion.p
                    initial={{ opacity: 0, x: -100 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={springMotion}
                  >
                    DARVIS
                  </motion.p>
                </div>
            </div>
            :<>
              <div className={styles.boxP}>
                <motion.p
                  initial={{ opacity: 0, x: -100 }}
                  animate={{ opacity: 1, x: 0, clipPath: 'inset(0 0 0 0)' }}
                  transition={springMotion}
                >
                  데이터 연결부터, 업무 실행까지 도와주는
                </motion.p>
              </div>
              <div className={styles.boxP}>
                <motion.p
                  initial={{ opacity: 0, x: 300 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={springMotion}
                >
                  AI 파트너, <span>DARVIS</span>
                </motion.p>
              </div>
            </>
          }
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              ...springMotion,
              delay: 1.0
            }}
          >
            <Button text='무료 컨설팅 신청하기'
                    width='206px'
                    height='53px'
                    padding='14px 28px'
                    backgroundColor='#825DFC'
                    border='none'
                    borderRadius='7px'
                    fontSize='18px'
                    fontWeight='700'
                    textColor='#FFF'
                    onClick={() => openNewWindow(CONSULTING_FORM_URL)}
            />
          </motion.div>
        </div>
        {/* <div className={styles.boxImg}>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={springMotion}
          >
            <ChatPageImg />
          </motion.div>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{
              ...springMotion,
              delay: 1.0
            }}
          >
            <ChartImg />
          </motion.div>
        </div> */}
        <motion.div
          className={styles.boxVideo}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={springMotion}
        >
          <video autoPlay muted loop playsInline>
            <source src={DemoVideo} />
          </video>
        </motion.div>
      </div>
    </div>
  );
}
